<template>
  <div class="page-template">
    <div class="page-title">{{ title }}
    </div>
    <div><span style="font-weight:bold">设置须知：</span>开启小程序商城后，才可以通过小程序进入门店
      <el-button @click="expressSet" icon="el-icon-setting" type="primary" plain style="margin-bottom: 5px">配送费设置
      </el-button>
    </div>
    <!--    <el-dialog class="batchAdd" title="配送费设置（请勿添加交错区间，否则会优先使用先添加的区间）" :visible.sync="expressShow" width="800px" height="800" :close-on-click-modal="false">-->
    <!--      <div>-->
    <!--        <batch-add ref="listOperation" :tableOptions="goodsAddColumns"></batch-add>-->
    <!--      </div>-->
    <!--      <div class="btn-box">-->
    <!--        <el-button @click="selectSubmit" type="primary">保存</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
    <el-dialog title='配送费设置' :visible.sync="expressShow" width="800px" @close="closeDialog" class="shipping-dialog">
      <el-button @click="addShipping" type="primary" style="margin: 0 0 10px 0" plain>新增</el-button>
      <el-form :model="form" :rules="rules" ref="form" class="shipping-form">
        <el-table
          :data="form.courierPriceList"
          border
          style="width: 100%"
          :cell-style="{height:34}"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="55">
          </el-table-column>
          <el-table-column
            prop="startDistance"
            label="配送距离起始值(km)"
          >
            <template slot-scope="scope">
              <el-input type="number" v-model="scope.row.startDistance"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="endDistance"
            label="配送距离结束值(km)"
          >
            <template slot-scope="scope">
              <el-input type="number" v-model="scope.row.endDistance"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            label="价格(元)"
          >
            <template slot-scope="scope">
              <el-input type="number" v-model="scope.row.price"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-button @click="deleteRow(scope)" type="text" style="margin: 0">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div style="text-align: center">
        <el-button @click="save" type="primary" style="margin: 10px 0 10px 0">保存</el-button>
      </div>
    </el-dialog>
    <div class="page-edit">
      <form-template ref="formTemplate" @submit="submitData">
      </form-template>
    </div>
  </div>
</template>
<script>
import formTemplate from "@/components/template/formTemplate";
import batchAdd from '@/components/business/batchAdd';
import api from "@/config/api";

export default {
  components: {
    formTemplate,
    batchAdd
  },
  data() {
    return {
      tableData: [],
      form: {
        courierPriceList: [],
      },
      rules: {},
      start: '',
      end: '',
      price: '',
      expressShow: false,
      title: '',
      dialogVisibility: false,
      addColumns: {
        formType: 'update',
        labelWidth: "200px",
        span: 12,
        columns: [
          {label: '基础信息', type: 'title', span: 24},
          {
            label: "是否开启小程序商城",
            type: "switch",
            prop: "openMall",
          },
          {
            label: "是否开启送货上门服务",
            type: "switch",
            prop: "openDelivery",
            change: this.openDeliveryChange
          },
          {
            label: "是否开启到店自提功能",
            type: "switch",
            prop: "openInvite",
          },
          // {
          //   label: "是否开启快递发货功能",
          //   type: "switch",
          //   prop: "openCourier",
          // },
          {
            label: "是否开启非营业时间支持下单",
            type: "switch",
            prop: "openOrder",
          },
          {
            label: "是否开启免配送费",
            type: "switch",
            prop: "openFree",
          },
          // {
          //   label: "配送",
          //   type: "title",
          //   prop: "title",
          //   span: 24,
          //   isShow: false,
          // },
          // {
          //   label: "配送方式",
          //   type: "select",
          //   prop: "deliveryType",
          //   isShow: false,
          //   data: this.$utils.getCacheStatus("seStore.deliveryType"),
          // },
          {label: '送货上门时间', type: 'title', span: 24},
          {
            label: "开始时间",
            prop: "deliveryStart",
            span: 12,
            type: 'timePicker',
          },
          {
            label: '结束时间',
            prop: 'deliveryEnd',
            span: 12,
            type: 'timePicker',
          },
          {label: '营业时间', type: 'title', span: 24},
          {
            label: "开始时间",
            prop: "businessStart",
            span: 12,
            type: 'timePicker',
          },
          {
            label: '结束时间',
            prop: 'businessEnd',
            span: 12,
            type: 'timePicker',
          },
          {label: '地址信息', type: 'title', span: 24},
          {
            label: "原地址",
            type: "input",
            prop: "detailAddress",
            span: 24
          },
          {
            label: "经度",
            type: "inputNumber",
            prop: "longitude",
            precision: 5,
            disabled: true,
            span: 12,
            rule: [{required: true, message: "请选择经度！"}]
          },
          {
            label: "纬度",
            type: "inputNumber",
            prop: "latitude",
            precision: 5,
            span: 12,
            disabled: true,
            rule: [{required: true, message: "请选择纬度！"}]
          },
          {
            label: '',
            type: 'map',
            prop: 'map',
            span: 24,
            lat: 'latitude',
            lon: 'longitude',
            labelWidth: 120,
          },
          {label: '其他设置', type: 'title', span: 24},
          {
            label: "推广语",
            type: "input",
            prop: "tip",
            placeholder: '本店开通送货上门欢迎大家下单',
            maxLength: "30"
          },
          {
            label: "门店电话",
            type: "input",
            prop: "mallPhone",
          },
          {
            label: "服务半径(米)",
            type: "inputNumber",
            prop: "radius",
            min: 0
          },
          {
            label: "起送价",
            type: "inputNumber",
            prop: "flagFall",
          },
          {
            label: "订单有效时长(秒)",
            type: "inputNumber",
            prop: "orderEffective",
          },
        ],
        url: api.store.storeInfo
      },
      goodsAddColumns: {
        columns: [
          {label: '序号', type: 'index', width: 30, prop: 'idx'},
          {label: '操作', type: 'operation', width: 40, prop: 'operation'},
          {
            label: '配送距离起始值(km)',
            prop: 'startDistance',
            width: '80',
            type: 'inputNumber',
            // placeholder:'起始值',
            precision: 2,
          },
          {
            label: '配送距离结束值(km)',
            prop: 'endDistance',
            width: '100',
            align: 'center',
            type: "inputNumber",
            // placeholder:'结束值',
            precision: 2,
          },
          {
            label: '价格(元)',
            prop: 'price',
            width: '80',
            align: 'center',
            type: "input",
            precision: 2,
            placeholder: "价格"
          },
        ],
        url: api.mall.expressSetting
      },
    };
  },
  mounted() {
    this.title = document.title;
    this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns, this.$utils.getSysUser().storeId);
  },
  methods: {
    // 新增配送费
    addShipping() {
      this.form.courierPriceList.push({startDistance: '', endDistance: '', price: ''})
    },
    // 配送费保存
    save() {
      let flag = false
      if (this.form.courierPriceList.length === 0) {
        this.$message.warning('保存数据不能为空')
      } else {
        flag = this.form.courierPriceList.every(v => {
          if (v.startDistance && v.endDistance && v.price) {
            return true
          }
        })
        if (flag) {
          this.saveData()
        } else {
          this.$message.warning('配送距离或配送费不能为空')
        }
      }
    },
    saveData() {
      this.$axios.fetchPost('/api/eros/mall/mallCourierPrice/batch', this.form).then(res => {
        if (res.code === 200) {
          this.$notify({
            type: "success",
            title: '保存操作',
            message: '成功',
            showClose: false,
          });
          // this.$message.success('保存成功')
          this.closeDialog()
        } else {
          this.$message.error(res.errorMsg)
        }
      }).catch(() => {
      })
    },
    // 删除配送费
    deleteRow(scope) {
      this.form.courierPriceList.splice(scope.$index, 1);
    },
    // 关闭配送费设置
    closeDialog() {
      this.expressShow = false
      this.form.courierPriceList = []
    },
    submitData() {
    },
    //配送费设置按钮
    expressSet() {
      this.getShippingList()
      this.expressShow = true;
      // this.$nextTick(() => {
      //   this.$refs["listOperation"].getTabelData();
      // })
    },
    // 配送费list
    getShippingList() {
      this.$axios.fetchPost(api.mall.expressSetting + '/list', {}).then(res => {
        this.form.courierPriceList = res.data
      }).catch(() => {
      })
    },
    // 送货上门
    openDeliveryChange(data) {
      let title = {
        isShow: null,
      }
      let deliveryType = {
        isShow: null,
      }
      this.addColumns.columns.forEach(item => {
        if (item.prop === "title") {
          title = item;
        }
        if (item.prop === "deliveryType") {
          deliveryType = item;
        }
      });
      data['deliveryType'] = '';
      if (data['openDelivery']) {
        title.isShow = true;
        deliveryType.isShow = true;
      } else {
        title.isShow = false;
        deliveryType.isShow = false;
      }
    },
    //保存
    selectSubmit() {
      this.$refs['listOperation'].tableData.forEach(item => {
        this.start = item.startDistance;
        this.end = item.endDistance;
        this.price = item.price;
      })
      let param = {startDistance: this.start, endDistance: this.end, price: this.price}
      this.$axios.fetchPost(api.mall.expressSetting, param).then(data => {
        if (data.code == 200) {
          this.$notify({
            type: "success",
            title: '添加操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '添加成功', type: 'success'});
        }
      })
      this.expressShow = false;
    },
  }
};
</script>
<style scoped>
>>> .column-title::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 5px;
  margin-bottom: 2px;
  background: rgb(95, 88, 230);
}

.el-button {
  margin-left: 100px;
}

>>> .el-table__header tr,
.el-table__header th {
  height: 34px;
}

>>> .el-table tr {
  height: 34px;
}
</style>




// WEBPACK FOOTER //
// src/page/mall/setting.vue